import {get} from 'lodash';

export default (state = {}, {coachId, res}: any) => {
  return {
    ...state,
    BBBContributors: {
      ...get(state, 'BBBContributors', {}),
      [coachId]: res,
    },
  };
};
